import { render } from "./qiankun.vue?vue&type=template&id=0f8ed76e&scoped=true"
import script from "./qiankun.vue?vue&type=script&lang=js"
export * from "./qiankun.vue?vue&type=script&lang=js"

import "./qiankun.vue?vue&type=style&index=0&id=0f8ed76e&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8ed76e"]])

export default __exports__